/**
 * Schedule Meeting manifest — `schedule-meeting` action.
 *
 * Walks any source → contact (must have email). Opens the create-meeting
 * modal (mounted globally by CreateMeetingModalContainer) with the resolved
 * contact pre-loaded as an attendee via `customerEmail`.
 *
 * For deals: walks deal → company → contact (pick).
 *
 * Note: a contact source does NOT take this resolver fast-path
 * (canDirectClientRedirect only auto-runs for company sources); from a contact
 * the legacy `scheduleMeeting` handler in communication-actions.ts opens the
 * same modal with the contact's own email/name. This clientRun handles the
 * company/deal/ticket → contact paths, where the resolver backfills `email`.
 */

import { MODAL_IDS } from "@wtc/ui";

import { registerActionManifest } from "./registry";

registerActionManifest({
  actionId: "schedule-meeting",
  label: "Schedule meeting",
  primaryEntity: "contact",
  requires: {
    entity: "contact",
    requiredFields: ["email"],
  },
  mode: "client-redirect",
  clientRun: (resolved, hooks) => {
    // Payload shape matches CreateMeetingModalData. The resolver backfills the
    // contact's email into `resolved.fields.email`; pass it so the modal
    // pre-populates the attendee list.
    hooks.openModal(MODAL_IDS.meetings.create, {
      customerEmail: resolved.fields.email,
      attendeeContactIds: resolved.targetIds,
      sourceEntity: resolved.sourceEntity,
      sourceId: resolved.sourceId,
    });
  },
});
